'use strict';
module.exports = Odigeo.Model.extend({
    dataUrl: 'getseatmapdescriptors',
    defaults: {},
    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    getDataRequestSettings: function() {
        return {
            type: 'GET',
            reset: true,
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        };
    },
    requestSuccessHandler: function(data) {
        if (!Odigeo._.isEmpty(data)) {
            this.widget.initializeSeatView.call(this.widget.view, this.toJSON());
            this.trigger('responseIsOK', data);
        }
    },
    getSeatsStatus: function() {
        return this.toJSON();
    },
    requestErrorHandler: function() {
        this.trigger('responseIsKO');
    },

    hasInfo: function() {
        return this.get('hasFlightDetails') && this.get('hasSeatMapInfo');
    },
});
